// eslint-disable-next-line import/prefer-default-export
export const recurrenceSuccesMsg =
  'All recurrence activities are successfully created';
